import { render, staticRenderFns } from "./StartupsTimeline.vue?vue&type=template&id=207caf6d&scoped=true&"
import script from "./StartupsTimeline.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsTimeline.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207caf6d",
  null
  
)

export default component.exports